<template>
  <v-container>
    <page-title title="select a subject to begin"></page-title>
    <v-list two-line>
      <v-list-item-group v-model="selected" active-class="purple--text">
        <template>
          <v-list-item v-for="(subject, index) in subjects" :key="index"
            :to="{ name: 'questions', params: { subject: subject.courseCode } }">
            <v-list-item-content>
              <!-- ---------subject title containing title and the time the subject was created----- -->
              <v-list-item-title class="d-flex justify-space-between"><span class="h2 text-capitalize mt-4 grey-text">{{
                  subject.title
              }}</span>
              </v-list-item-title>

              <!-- ---------subject detail containing details of the  subject was ---- -->
              <!---TODO: change display from none=-------->
              <v-list-item-subtitle v-text="subject.description"></v-list-item-subtitle>
            </v-list-item-content>

            <!----on click of each mutate the global subject count, reducing by one----------->
            <v-list-item-action>
              <v-list-item-action-text> </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="index < subjects.length - 1" :key="index" class="my-1"></v-divider>
        </template>
      </v-list-item-group>
    </v-list>
  </v-container>
</template>

<script>
import PageTitle from "../../components/PageTitle.vue";

export default {
  components: {
    PageTitle,
  },
  data: () => ({
    selected: "",
    subjects: [
      { title: "english", courseCode: "english", description: "UTME and 100 Level standard" },
      {
        title: "mathematics",
        courseCode: "mathematics",
        description: "UTME and 100 Level standard",
      },
      {
        title: "physics",
        courseCode: "physics",
        description: "UTME and 100 Level standard"
      },
      {
        title: "chemistry",
        courseCode: "chemistry",
        description: "CHM 101, CHM 102, CHM 103, CHM 104, CHM 106",
      },
      {
        title: "biology",
        courseCode: "biology",
        description: "BIO 101",
      },
      {
        title: "CSC 201",
        courseCode: "csc201",
        description: "Introduction to Computer Science",
      },
    ],
  }),
};
</script>

<style>

</style>